import React, { Component } from 'react';

import Dico from '../../helpers/Dico'
import IconRender from '../std/IconRender';

class DisplayLine extends Component {

	render() {
		var styleIndent = { marginRight: '5px' };
		const indent = this.props.data.styleType != null ? this.props.data.styleType.indent : null;
		var style = Dico.getStyle(this.props.data.styleType, true);
		var styleValue = Dico.getStyle(this.props.data.styleType, false);
		styleValue.textAlign = 'right';

		const xsSizeLeftGrid = `col ${(this.props.data.displayValue == null || this.props.data.displayValue.length === 0 ? 'col-12' : 'col-8')}`;
		const xsSizeRightGrid = `col ${(this.props.data.displayValue == null || this.props.data.displayValue.length === 0 ? '' : 'col-4')}`;
		return (
			<div className='row'>
				<div className={xsSizeLeftGrid}>
					<span style={style}>
						{indent && <span style={styleIndent}><IconRender name="check" /></span>}
						{this.props.data.label}
					</span>
				</div>
				{xsSizeRightGrid && <div className={xsSizeRightGrid}>
					<span style={styleValue}>{this.props.data.displayValue}</span>
				</div>}
			</div>
		)
	}
}

export default DisplayLine
